module.exports = __webpack_public_path__ + "static/performancemetricskenfee-c50790dddcce0d4f6880107f2181a630.png";